import React from 'react';

export default function Contact() {
  return (
    <section id="contact" className="min-h-screen flex items-center justify-center px-6 py-20">
      <div className="max-w-4xl w-full">
        <h2 className="text-5xl md:text-7xl font-light mb-12">Let's Connect</h2>
        <div className="space-y-8">
          <p className="text-xl text-gray-700 leading-relaxed">
            For performance engagements, masterclasses, private lessons, or special events, please reach out directly. 
            I look forward to bringing music to your stage.
          </p>
          <div className="flex flex-col md:flex-row gap-6 text-lg">
            <a href="mailto:your@email.com" className="text-gray-900 hover:text-gray-600 transition-colors">
              your@email.com
            </a>
            <span className="hidden md:block text-gray-300">|</span>
            <a href="https://www.linkedin.com/in/erika-hubbard-038909ab/" target="_blank" rel="noopener noreferrer" className="text-gray-900 hover:text-gray-600 transition-colors">
              LinkedIn
            </a>
            <span className="hidden md:block text-gray-300">|</span>
            <a href="https://www.youtube.com/@erikahubbard6942" target="_blank" rel="noopener noreferrer" className="text-gray-900 hover:text-gray-600 transition-colors">
              Youtube
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}